type ApiResponseType = ApiSchema['ListingResponse'];
interface ParamsType { }

/**
 * Loads listing details for a specific listingId
 */
export default async function apiLoadListingDetails<T extends ListingDetails>(listingId: string | undefined): Promise<ApiResult<T>> {
    try {
        return await callApiGet<T, ApiResponseType, ParamsType>(
            `/listings/${listingId}`,

            // Request body
            {},

            // Transform result
            (response: ApiResponseType): T => {
                return transformListingDetails(response.listing) as T;
            },
        );
    }
    catch (error) {
        throw new Error('Failed to load esav listing details', { cause: error });
    }
}
